<template>
  <div class="loading">
    <img v-if="isBlack" src="@/assets/images/oval-black.svg">
    <img v-else src="@/assets/images/oval.svg">
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: ['isBlack']
}
</script>

<style lang="scss" scoped>

.loading {

  width:          100%;
  height:         100%;

  > img {
    margin:       0 auto;
    display:      block;
    height:       100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/utilities/LoadingSpinner.vue